module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/internet/free_email.js
// module id = 1241
// module chunks = 0